import React, { useState, useContext } from 'react';
import { Helmet } from 'react-helmet';
import { Layout } from '../components';
import {
  Typography,
  TextField,
  Button,
  makeStyles,
  InputAdornment,
  IconButton,
  InputLabel,
  FormControl,
  FormHelperText,
  OutlinedInput,
  Link as MuiLink,
} from '@material-ui/core';
import validator from 'validator';

import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

import { Link } from 'react-router-dom';
import { auth } from '../utils/firebase';

import { AppContext } from '../context/AppContext';
import { AuthContext } from '../context/AuthContext';
import ResetPassword from '../components/ResetPassword';

const useStyles = makeStyles({
  title: {
    fontWeight: '700',
  },
  subtitle: {
    marginBottom: '50px',
  },
  input: {
    marginBottom: '25px',
  },
  forgotPass: {
    margin: '25px 0px',
  },
});

export default function LoginScreen({ history }) {
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState(null);
  const [password, setPassword] = useState('');
  const [passwordError, setPasswordError] = useState(null);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [resetPasswordVisible, setResetPasswordVisible] = useState(false);

  const { snack: _snack, isLoading: _isLoading } = useContext(AppContext);
  const { setCurrentUser } = useContext(AuthContext);

  const setSnack = _snack[1];
  const [isLoading, setIsLoading] = _isLoading;

  const classes = useStyles();
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === 'email') {
      setEmail(value);

      if (!value) {
        setEmailError('Email is required');
      } else if (!validator.isEmail(value)) {
        setEmailError('Email is invalid');
      } else {
        setEmailError(null);
      }
    } else if (name === 'password') {
      setPassword(value);

      if (!value) {
        setPasswordError('Password is required');
      } else {
        setPasswordError(null);
      }
    }
  };

  const handleLogin = () => {
    setIsLoading(true);

    auth
      .signInWithEmailAndPassword(email, password)
      .then((data) => {
        setCurrentUser({
          email: data.user.email,
          uid: data.user.uid,
          username: data.user.displayName,
        });
        setSnack({
          open: true,
          status: 'success',
          message: 'Signed in sucessfully',
        });

        setIsLoading(false);
        history.push('/');
      })
      .catch((err) => {
        if (/^auth/.test(err.code)) {
          setSnack({
            open: true,
            status: 'error',
            message: 'Invalid email or password',
          });
        } else {
          setSnack({
            open: true,
            status: 'error',
            message: 'Sign in failed, unknwon error!',
          });
        }
        setIsLoading(false);
      });
  };

  return (
    <>
      <Helmet>
        <title>Chatty - Sign in</title>
      </Helmet>
      <Layout>
        <Typography
          align='center'
          color='secondary'
          variant='h2'
          className={classes.title}
        >
          Sign in
        </Typography>
        <Typography
          align='center'
          variant='subtitle1'
          color='textSecondary'
          className={classes.subtitle}
        >
          Sign in with your email and password
        </Typography>
        <TextField
          variant='outlined'
          label='Email'
          className={classes.input}
          type='email'
          value={email}
          onChange={handleChange}
          name='email'
          error={emailError ? true : false}
          helperText={emailError}
          disabled={isLoading}
        />
        <FormControl variant='outlined' className={classes.input}>
          <InputLabel
            htmlFor='outlined-adornment-password'
            error={passwordError ? true : false}
          >
            Password
          </InputLabel>
          <OutlinedInput
            id='outlined-adornment-password'
            type={passwordVisible ? 'text' : 'password'}
            endAdornment={
              <InputAdornment position='end'>
                <IconButton
                  aria-label='toggle password visibility'
                  onClick={() => setPasswordVisible(!passwordVisible)}
                  onMouseDown={() => setPasswordVisible(!passwordVisible)}
                  edge='end'
                >
                  {passwordVisible ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            }
            labelWidth={70}
            value={password}
            onChange={handleChange}
            name='password'
            error={passwordError ? true : false}
            disabled={isLoading}
          />
          <FormHelperText error={true}>{passwordError}</FormHelperText>
        </FormControl>
        <Button
          variant='contained'
          color='secondary'
          disabled={
            passwordError || emailError || !email || !password || isLoading
              ? true
              : false
          }
          onClick={handleLogin}
        >
          sign in
        </Button>
        <Typography
          className={classes.forgotPass}
          variant='body2'
          align='center'
          color='textSecondary'
        >
          Forgot password?{' '}
          <MuiLink
            style={{ cursor: 'pointer' }}
            onClick={() => setResetPasswordVisible(true)}
          >
            Reset password
          </MuiLink>
        </Typography>
        <Typography variant='body2' align='center' color='textSecondary'>
          Not registered?{' '}
          <Link to='/register' style={{ textDecoration: 'none' }}>
            <MuiLink>Create account</MuiLink>
          </Link>
        </Typography>
      </Layout>
      {resetPasswordVisible && (
        <ResetPassword
          open={resetPasswordVisible}
          setOpen={setResetPasswordVisible}
        />
      )}
    </>
  );
}
